import { HKDF_INFO_LABEL, HKDF_OUTPUT_BYTES } from '../constants';

import { getSubtleCrypto } from './subtle';

export async function deriveHkdfKey(
  ikm: Uint8Array,
  salt: Uint8Array,
  usages: KeyUsage[] = ['encrypt', 'decrypt'],
): Promise<CryptoKey> {
  const subtle = getSubtleCrypto();
  const hkdfKey = await subtle.importKey('raw', ikm as BufferSource, 'HKDF', false, [
    'deriveKey',
  ]);
  const info = new TextEncoder().encode(HKDF_INFO_LABEL);

  return subtle.deriveKey(
    {
      name: 'HKDF',
      salt: salt as BufferSource,
      hash: 'SHA-256',
      info: info as BufferSource,
    },
    hkdfKey,
    {
      name: 'AES-GCM',
      length: HKDF_OUTPUT_BYTES * 8,
    },
    false,
    usages,
  );
}

export async function deriveHkdfBytes(
  ikm: Uint8Array,
  salt: Uint8Array,
): Promise<Uint8Array> {
  const subtle = getSubtleCrypto();
  const hkdfKey = await subtle.importKey('raw', ikm as BufferSource, 'HKDF', false, [
    'deriveBits',
  ]);
  const info = new TextEncoder().encode(HKDF_INFO_LABEL);
  const bits = await subtle.deriveBits(
    {
      name: 'HKDF',
      salt: salt as BufferSource,
      hash: 'SHA-256',
      info: info as BufferSource,
    },
    hkdfKey,
    HKDF_OUTPUT_BYTES * 8,
  );

  return new Uint8Array(bits);
}
